// extracted by mini-css-extract-plugin
export default {"add-btn":"UXkDBruETbe4l3V3yF2i"};